module.exports = __webpack_public_path__ + "img/financely.a4df2c1f.png";